import { Component, Vue } from 'vue-property-decorator';
import { AppointmentDetailsDTO } from '@/models/AppointmentDetailsDTO';
import { GetterTypes } from '@/store-vuex/types';
import InformationBlock from '@/components/InformationBlock/InformationBlock';
import AppointmentSpecials from '@/components/AppointmentSpecials/AppointmentSpecials';

@Component({
    components: {
        AppointmentSpecials,
        InformationBlock,
    },
})
export default class AppointmentDetails extends Vue {
    public showPrevButton: boolean = false;
    private appointDetails!: AppointmentDetailsDTO;
    private get suName() { return this.$route.params.screening; }

    public get useTRMGenderChoice(): boolean {
        return this.$store.getters[GetterTypes.useTRMGenderChoice];
    }

    public get useLongAppointment(): boolean {
        return this.$store.getters[GetterTypes.useLongAppointment];
    }

    public get allowFirstAppointment(): boolean {
        return this.$store.getters[GetterTypes.allowFirstAppointment];
    }

    public get isParticipantFirstAppointment(): boolean {
        return this.$store.getters[GetterTypes.isFirstAppointment];
    }

    public get showFirstAppointmentNotAllowed(): boolean {
        return !this.allowFirstAppointment && this.isParticipantFirstAppointment;
    }

    protected async mounted() {
        if (!this.useTRMGenderChoice && !this.useLongAppointment && !this.showFirstAppointmentNotAllowed) {
            this.next();
        }

        if (this.showAppointmentParticipantStep) {
            this.showPrevButton = true;
        }
    }

    protected next() {
        this.$router.push({
            name: 'appointment-selection',
            params: {
                screening: this.$route.params.screening,
            },
        });
    }

    /**
   * Gets true if AppointmentParticipant step must be displayed
   *
   * @returns {boolean} true or false
   */
  public get showAppointmentParticipantStep(): boolean {
      return this.$store.getters[GetterTypes.showAppointmentParticipantStep];
  }
}
